export function formatNumber(num) {
    if (num >= 1_000_000_000) {
      // Billion
      return (num / 1_000_000_000).toFixed(1) + 'B';
    } else if (num >= 1_000_000) {
      // Million
      return (num / 1_000_000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      // Thousand
      return (num / 1000).toFixed(1) + 'k';
    } else {
      return num; // Return the number as is if it's less than 1000
    }
  }


  export  function formatNumberWithString(val) {
    if (val >= 1000000) {
      return (val / 1000000).toFixed(1) + 'M';
    } else if (val >= 1000) {
      return (val / 1000).toFixed(1) + 'k';
    } else if (val > 0) {
      return val.toString();
    } else if (val == 0) {
      return 0;
    } else {
      return '';
    }
  }

  export function formatNumberCompact(value) {
    if (value == null || isNaN(value)) return '';
  
    const absVal = Math.abs(value);
  
    if (absVal >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(1) + 'B';
    } else if (absVal >= 1_000_000) {
      return (value / 1_000_000).toFixed(1) + 'M';
    } else if (absVal >= 1_000) {
      return (value / 1_000).toFixed(1) + 'k';
    } else if (value === 0) {
      return '0';
    } else if (value > 0) {
      return value.toString();
    } else {
      return '';
    }
  }
  